var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFoodCover = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "18px",
  viewBox: "0 0 24 18",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mobile-start",
  transform: "translate(-176.000000, -1257.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Diets",
  transform: "translate(0.000000, 1230.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Budicon-Solid/Kitchen/food-cover",
  transform: "translate(176.000000, 24.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M23.52,19.2 L23.0208,19.2 C23.029248,19.040544 23.04,18.881664 23.04,18.72 C23.038943,13.8556272 19.8546911,9.56496721 15.1992,8.154816 C15.3004493,7.8464261 15.3546577,7.52454156 15.36,7.2 C15.36,5.34432324 13.8556768,3.84 12,3.84 C10.1443232,3.84 8.64,5.34432324 8.64,7.2 C8.64557257,7.5264087 8.70059777,7.85008634 8.8032,8.16 C4.99287422,9.31691585 2.09951798,12.4341638 1.22928,16.32 L13.92,16.32 C14.1850967,16.32 14.4,16.5349033 14.4,16.8 C14.4,17.0650967 14.1850967,17.28 13.92,17.28 L1.064544,17.28 C0.998465735,17.7572208 0.963543801,18.2382392 0.96,18.72 C0.96,18.881664 0.970752,19.040544 0.9792,19.2 L0.48,19.2 C0.21490332,19.2 0,19.4149033 0,19.68 C0,19.9450967 0.21490332,20.16 0.48,20.16 L23.52,20.16 C23.7850967,20.16 24,19.9450967 24,19.68 C24,19.4149033 23.7850967,19.2 23.52,19.2 L23.52,19.2 Z M14.271936,7.916352 C12.7747379,7.59883068 11.2273469,7.60121883 9.731136,7.92336 C9.6482162,7.69101885 9.60391763,7.44666325 9.6,7.2 C9.6,5.8745166 10.6745166,4.8 12,4.8 C13.3254834,4.8 14.4,5.8745166 14.4,7.2 C14.396308,7.44413597 14.3530589,7.68605856 14.271936,7.916352 L14.271936,7.916352 Z",
  fill: "currentColor",
  fillRule: "nonzero"
}))))))));
export default SvgFoodCover;